import type { QueryClient } from '@tanstack/react-query';
import type { CpGpMatchedProduct } from '../../../../../models/Coupang';
import type { GlowpickProduct, ScAgentEngData } from '../../../../../models/Glowpick';

interface ProductInfoCacheTarget {
  gpProductId: string;
  cpProductId?: string;
  cpItemId?: string;
}

export const applySavedProductInfoToCache = (
  queryClient: QueryClient,
  target: ProductInfoCacheTarget,
  scAgentEngData: ScAgentEngData,
): void => {
  queryClient.setQueryData<GlowpickProduct | undefined>(['glowpickProduct', target.gpProductId], (current) => {
    if (!current) {
      return current;
    }

    return {
      ...current,
      scAgentEngData,
    };
  });

  if (!target.cpProductId || !target.cpItemId) {
    return;
  }

  queryClient.setQueryData<CpGpMatchedProduct | undefined>(
    ['cpGpMatch', target.cpProductId, target.cpItemId],
    (current) => {
      if (!current?.gpDetailedProduct) {
        return current;
      }

      return {
        ...current,
        gpDetailedProduct: {
          ...current.gpDetailedProduct,
          scAgentEngData,
        },
      };
    },
  );
};
